import './HomePage.scss'
import HomePage from './HomePage'

export default HomePage